// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"ep-z","slideIn":"fp-z"};